import { render, staticRenderFns } from "./FrameworkSequenceDetail.vue?vue&type=template&id=0437a66c"
import script from "./FrameworkSequenceDetail.vue?vue&type=script&lang=js"
export * from "./FrameworkSequenceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports